module.exports = __webpack_public_path__ + "owen-36e27b1347e92eedc2c77f6162402e5f.png";